import { Reducer } from "redux";
import { OrganizationKeyName } from "../../model/Organization";
import { MonitorEventData } from "../../service/api-response/MonitorEventsSuccessResponse";
import * as userMonitorEventActions from "./userMonitorEventActions";
import { MonitorEventListFilters } from "../../service/ApiMonitorEvent";
import * as objectHash from "object-hash";

export interface UserMonitorEventState {
  org: {
    [orgAndUserId: string]:
      | undefined
      | {
          monitorEvents?: MonitorEventData[];
          nextPageUrl?: string;
          hasMore?: boolean;
          isLoading?: boolean;
        };
  };
}

const initialState: UserMonitorEventState = {
  org: {},
};

type SupportedActions =
  | userMonitorEventActions.GetUserMonitorEventListAction
  | userMonitorEventActions.GetUserMonitorEventListSuccessAction
  | userMonitorEventActions.GetUserMonitorEventListFailAction;

export const getKey = (
  organization: OrganizationKeyName,
  filters: MonitorEventListFilters
): string => {
  return objectHash.MD5(filters);
};

export const userMonitorEventReducer: Reducer<
  UserMonitorEventState,
  SupportedActions
> = (state = initialState, action) => {
  switch (action.type) {
    case userMonitorEventActions.GET_USER_MONITOR_EVENT_LIST: {
      const key = getKey(action.organization, action.filters);
      const isFirstPageRequest =
        action.subtype ===
        userMonitorEventActions.GetUserMonitorSubtype.LoadFirstPage;

      if (isFirstPageRequest) {
        return {
          ...state,
          org: {
            ...state.org,
            [key]: {
              ...state.org[key],
              isLoading: true,
              hasMore: false,
              nextPageUrl: "",
              monitorEvents: [],
            },
          },
        };
      } else {
        return {
          ...state,
          org: {
            ...state.org,
            [key]: {
              ...state.org[key],
              isLoading: true,
            },
          },
        };
      }
    }
    case userMonitorEventActions.GET_USER_MONITOR_EVENT_LIST_FAIL: {
      const key = getKey(action.organization, action.filters);
      return {
        ...state,
        org: {
          ...state.org,
          [key]: {
            isLoading: false,
            nextPageUrl: "",
            hasMore: false,
          },
        },
      };
    }
    case userMonitorEventActions.GET_USER_MONITOR_EVENT_LIST_SUCCESS: {
      const key = getKey(action.organization, action.filters);
      const monitorEvents: MonitorEventData[] = [];

      if (
        state.org[key] &&
        state.org[key]!.monitorEvents &&
        state.org[key]!.monitorEvents!.length
      ) {
        monitorEvents.push(...(state.org[key]!.monitorEvents || []));
      }

      monitorEvents.push(...action.data.monitor_events.items);

      return {
        ...state,
        org: {
          ...state.org,
          [key]: {
            isLoading: false,
            nextPageUrl:
              action.data.monitor_events &&
              action.data.monitor_events.links &&
              action.data.monitor_events.links.next_page,
            hasMore:
              action.data.monitor_events &&
              action.data.monitor_events.items &&
              action.data.monitor_events.items.length > 0,
            monitorEvents,
          },
        },
      };
    }
    default: {
      return state;
    }
  }
};
